import Link from "next/link";
import React from "react";
import MatchAVenir from "./MatchAVenir";

const MatchsAVenir: React.FC<any> = ({ matchAVenir }) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {matchAVenir.slice(0, 3).map((match, key) => {
          try {
            if (match.fields) {
              const adversaire = match.fields.adversaire;
              const adversaireLogo = match.fields.logoAdversaire && `https:${match.fields.logoAdversaire.fields.file.url}`;
              const competition = match.fields.competition;
              const bestOf = match.fields.bestOf;
              const dateMatch = match.fields.dateMatch;
              const infoSup = match.fields.infoSup;
              const equipeDeathrow: string = match.fields.equipeDeathrow?.fields.nom ? match.fields.equipeDeathrow.fields.nom : undefined;
              const lien: string = match.fields.lien;

              return (
                <MatchAVenir
                  key={key}
                  adversaire={adversaire}
                  adversaireLogo={adversaireLogo}
                  competition={competition}
                  bestOf={bestOf}
                  dateMatch={dateMatch}
                  infoSup={infoSup}
                  equipeDeathrow={equipeDeathrow}
                  lien={lien}
                />
              );
            }
          } catch (ex) {
            throw new Error(`Error while fetching futures matches : ${ex}`);
          }
        })}
      </div>
      <div className="flex justify-end">
        <Link href="/equipes" passHref>
          <a
            aria-label="Aller sur la page des équipes"
            className="group mt-4 inline-flex items-center text-xs font-semibold uppercase tracking-wider text-redAccent"
          >
            Voir nos équipes
            <svg
              className="ml-2 inline-block w-3 transform transition duration-500 ease-in-out group-hover:translate-x-1 group-focus:translate-x-1"
              fill="currentColor"
              viewBox="0 0 12 12"
            >
              <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
            </svg>
          </a>
        </Link>
      </div>
    </>
  );
};

export default MatchsAVenir;
